<template>
  <div class="pt-3">
    <b-card
      header="Details"
      header-tag="h4"
      header-bg-variant="white"
    >
      <b-container>
        <b-row>
          <b-col>
            <b-form-group
              label="Campaign Name"
              label-cols-lg="3"
            >
              <b-form-input
                type="text"
                placeholder="Campaign Name"
                required
                v-model="name"
              />
            </b-form-group>

            <b-form-group
              label="Category"
              label-cols-lg="3"
            >
              <b-form-input
                placeholder="Category"
                type="text"
                autocomplete="off"
                ref="category"
                v-model="category_name"
              ></b-form-input>

              <datalist id="categories">
                <option
                  v-for="category in categories"
                  :key="category.id"
                >{{category}}</option>
              </datalist>

              <b-form-text>Group this with similar campaigns</b-form-text>
            </b-form-group>

            <b-form-group
              label="Filter"
              label-cols-lg="3"
            >
              <b-form-select v-model="filter_id" @change="filterChanged">
                <option disabled hidden selected>Choose a filter...</option>
                <option
                  v-for="filter in getFilters"
                  :key="filter._id"
                  :value="filter._id"
                >{{filter.name}}</option>
              </b-form-select>
              <b-form-text>All contacts within the filter will receive emails from the campaign</b-form-text>
            </b-form-group>

            <b-form-group
              label="Filter Type"
              label-cols-lg="3"
            >
              <b-form-select v-model="filter_model">
                <option disabled hidden selected>Choose a filter type...</option>
                <option
                  v-for="model in filterModels"
                  :key="model.value"
                  :value="model.value"
                >{{model.text}}</option>
              </b-form-select>
            </b-form-group>

            <b-form-group
              label="Assign agent"
              label-cols-lg="3"
            >
              <b-form-select v-model="agent">
                <option disabled hidden selected>Assign an agent</option>
                <option
                  v-for="a in getAgents"
                  :key="a.value"
                  :value="a.value"
                >{{a.text}}</option>
              </b-form-select>
            </b-form-group>

            <b-form-group
              label-cols-lg="3"
            >
              <b-form-checkbox
                value="true"
                unchecked-value="false"
                v-model="use_assigned_agent"
              >
                Use Assigned Agent
              </b-form-checkbox>
            </b-form-group>
            <b-form-group
              label-cols-lg="3"
            >
              <b-form-checkbox
                value="true"
                unchecked-value="false"
                v-model="only_unique_emails"
              >
                Do not send to same email twice
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              label-cols-lg="3"
            >
              <b-form-radio-group v-model="active">
                <b-form-radio :value="true">Automated</b-form-radio>
                <b-form-radio :value="false">Manual</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
           </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import store from '../store'
import serializer from '../components/LayoutEditor/serializer'

export default {
  beforeRouteEnter(to, from, next) {
    let filtersPromise = store.dispatch('filters/fetchAll')
    let categoriesPromise = store.dispatch('campaign_categories/fetchAll')

    let promises = []

    if ('id' in to.params) {
      promises = Promise.all([
        filtersPromise,
        categoriesPromise,
        store.dispatch('campaigns/fetchOne', to.params.id)
      ])
    } else {
      promises = Promise.all([
        filtersPromise,
        categoriesPromise,
        store.dispatch('campaigns/newCampaign')
      ])
    }

    promises
      .then(() => {
        if ('query' in to && 'category_name' in to.query) {
          store.dispatch('campaigns/updateAttribute', { attribute: 'category_name', value: to.query.category_name })
        }
      })
      .then(() => next())
  },

  mounted() {
    // need to manually mount list attribute because b-input doesn't support it
    this.$refs['category'].$el.setAttribute('list', 'categories')
  },

  data() {
    return {
      emailSent: false,
      filterModels: [
        { text: 'Application', value: 'application' },
        { text: 'Contact', value: 'contact' },
        { text: 'Lead', value: 'lead' }
      ],
      agents: [
        {
          "_id": {
            "$oid": "662974211e8a8ddd27fc5629"
          },
          "contact": [
            {
              "firstName": "Cannect",
              "lastName": "Team",
            }
          ],
          "accountEmailAddress": "hello@cannect.ca",

        },
        {
          "_id": {
            "$oid": "64c2c926674b5f00127e1605"
          },
          "accountEmailAddress": "phil.carvalho@cannect.ca",
          "contact": [
            {
              "firstName": "Phil",
              "lastName": "Carvalho"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e508"
          },
          "accountEmailAddress": "simon.hanvey@cannect.ca",
          "contact": [
            {
              "firstName": "Simon Hanvey -",
              "lastName": "Cannect"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e50b"
          },
          "accountEmailAddress": "srajapakse@oscarcrm.com",
          "contact": [
            {
              "firstName": "Sandu",
              "lastName": "Rajapakse - OLD"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e50e"
          },
          "accountEmailAddress": "no_user-travis-allinott@mortgagecrm.herokuapp.com",
          "contact": [
            {
              "firstName": "Travis",
              "lastName": "Allinott"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e512"
          },
          "accountEmailAddress": "no_user-john-benstead@mortgagecrm.herokuapp.com",
          "contact": [
            {
              "firstName": "John",
              "lastName": "Benstead"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e518"
          },
          "accountEmailAddress": "no_user-edgar-rivera@nodomain.com",
          "contact": [
            {
              "firstName": "Edgar",
              "lastName": "Rivera"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e521"
          },
          "accountEmailAddress": "m@morcandirect.com",
          "contact": [
            {
              "firstName": "Marcus Tzaferis - MorCan",
              "lastName": "Direct"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e539"
          },
          "accountEmailAddress": "elisseos@safebridgefinancial.com",
          "contact": [
            {
              "firstName": "Elisseos",
              "lastName": "Iriotakis"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e59c"
          },
          "accountEmailAddress": "michael+sb@mglenn.com",
          "contact": [
            {
              "firstName": "Michael",
              "lastName": "Glenn"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e59e"
          },
          "accountEmailAddress": "j@morcanwest.ca",
          "contact": [
            {
              "firstName": "Jordell",
              "lastName": "James"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5a1"
          },
          "accountEmailAddress": "srajapakse@oscarintelligence.com",
          "contact": [
            {
              "firstName": "Sandu",
              "lastName": "Rajapakse"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5a2"
          },
          "accountEmailAddress": "sheldon@cannect.ca",
          "contact": [
            {
              "firstName": "Sheldon",
              "lastName": "Moskovici"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5a3"
          },
          "accountEmailAddress": "rahul@cannect.ca",
          "contact": [
            {
              "firstName": "Rahul",
              "lastName": "Suresh"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5a6"
          },
          "accountEmailAddress": "jayson@cannect.ca",
          "contact": [
            {
              "firstName": "Jayson",
              "lastName": "Fowler"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5aa"
          },
          "accountEmailAddress": "lily@cannect.ca",
          "contact": [
            {
              "firstName": "Lily",
              "lastName": "Guan"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ab"
          },
          "accountEmailAddress": "peter.drecun@morcandirect.com",
          "contact": [
            {
              "firstName": "Peter",
              "lastName": "Drecun"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ac"
          },
          "accountEmailAddress": "himanshuoberoi75@gmail.com",
          "contact": [
            {
              "firstName": "Himanshu",
              "lastName": "Oberoi"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ad"
          },
          "accountEmailAddress": "semere@cannect.ca",
          "contact": [
            {
              "firstName": "Semere",
              "lastName": "Mengustu"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5af"
          },
          "accountEmailAddress": "sindhu@cannect.ca",
          "contact": [
            {
              "firstName": "Sindhu",
              "lastName": "Reddy"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5b0"
          },
          "accountEmailAddress": "m@cannect.ca",
          "contact": [
            {
              "firstName": "Marcus",
              "lastName": "Tzaferis"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5b1"
          },
          "accountEmailAddress": "psoy@cannect.ca",
          "contact": [
            {
              "firstName": "Patrick",
              "lastName": "Soy"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5b2"
          },
          "accountEmailAddress": "tahir.raja@morcandirect.com",
          "contact": [
            {
              "firstName": "Tahir",
              "lastName": "Raja"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5b3"
          },
          "accountEmailAddress": "izamojc@oscarcrm.com",
          "contact": [
            {
              "firstName": "Ian",
              "lastName": "Zamojc"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5b5"
          },
          "accountEmailAddress": "demo@cannect.ca",
          "contact": [
            {
              "firstName": "Lee",
              "lastName": "Dale"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5b6"
          },
          "accountEmailAddress": "mgrieve@maggnumventures.com",
          "contact": [
            {
              "firstName": "Matthew",
              "lastName": "Grieve"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5b7"
          },
          "accountEmailAddress": "rosalynd.kochhar@morcandirect.com",
          "contact": [
            {
              "firstName": "Rosalynd",
              "lastName": "Kochhar"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5b8"
          },
          "accountEmailAddress": "anastasia.pavlova@morcandirect.com",
          "contact": [
            {
              "firstName": "Anastasia",
              "lastName": "Pavlova"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ba"
          },
          "accountEmailAddress": "simon.hanvey@morcandirect.com",
          "contact": [
            {
              "firstName": "Simon",
              "lastName": "Hanvey"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5bc"
          },
          "accountEmailAddress": "diana@cannect.ca",
          "contact": [
            {
              "firstName": "Diana",
              "lastName": "Perdomo"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5bd"
          },
          "accountEmailAddress": "joanne@cannect.ca",
          "contact": [
            {
              "firstName": "Joanne",
              "lastName": "Bateman"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5c1"
          },
          "accountEmailAddress": "alex@cannect.ca",
          "contact": [
            {
              "firstName": "Alex",
              "lastName": "Zhu"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5c5"
          },
          "accountEmailAddress": "bruce@cannect.ca",
          "contact": [
            {
              "firstName": "Bruce",
              "lastName": "Langstaff"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5c6"
          },
          "accountEmailAddress": "laura@cannect.ca",
          "contact": [
            {
              "firstName": "Laura",
              "lastName": "Perdomo"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5c7"
          },
          "accountEmailAddress": "jeltahan@oscarintelligence.com",
          "contact": [
            {
              "firstName": "Jocelyne El",
              "lastName": "Tahan"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5c8"
          },
          "accountEmailAddress": "laura@whiteandgale.com",
          "contact": [
            {
              "firstName": "Laura",
              "lastName": "Gale"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5c9"
          },
          "accountEmailAddress": "alex.b@cannect.ca",
          "contact": [
            {
              "firstName": "Alexander",
              "lastName": "Burgess"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ca"
          },
          "accountEmailAddress": "hello@sayyeah.com",
          "contact": [
            {
              "firstName": "Say",
              "lastName": "Yeah"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5cc"
          },
          "accountEmailAddress": "lee@oscarcrm.com",
          "contact": [
            {
              "firstName": "Lee",
              "lastName": "Dale"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ce"
          },
          "accountEmailAddress": "kthomas@hss-ca.com",
          "contact": [
            {
              "firstName": "",
              "lastName": "Kevin"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5cf"
          },
          "accountEmailAddress": "bhalinder.khangura@morcandirect.com",
          "contact": [
            {
              "firstName": "Bhalinder",
              "lastName": "Khangura"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5d1"
          },
          "accountEmailAddress": "joanne.bateman@morcandirect.com",
          "contact": [
            {
              "firstName": "Joanne Bateman -",
              "lastName": "MorcanDirect"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5d2"
          },
          "accountEmailAddress": "lee@sayyeah.com",
          "contact": [
            {
              "firstName": "Lee",
              "lastName": "Dale"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5d3"
          },
          "accountEmailAddress": "nikko@cannect.ca",
          "contact": [
            {
              "firstName": "Nikko",
              "lastName": "Campbell"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5d5"
          },
          "accountEmailAddress": "justin.turner@cannect.ca",
          "contact": [
            {
              "firstName": "Justin",
              "lastName": "Turner"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5d7"
          },
          "accountEmailAddress": "lisa.quinn@morcandirect.com",
          "contact": [
            {
              "firstName": "Lisa",
              "lastName": "Quinn"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5d8"
          },
          "accountEmailAddress": "dylan@cannect.ca",
          "contact": [
            {
              "firstName": "Dylan",
              "lastName": "McBurney"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5d9"
          },
          "accountEmailAddress": "joshua.johnston@morcandirect.com",
          "contact": [
            {
              "firstName": "Joshua",
              "lastName": "Johnston"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5db"
          },
          "accountEmailAddress": "cameron.brown+sb@morcandirect.com",
          "contact": [
            {
              "firstName": "Cameron Brown",
              "lastName": "(SafeBridge)"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5dc"
          },
          "accountEmailAddress": "latoya@cannect.ca",
          "contact": [
            {
              "firstName": "Latoya",
              "lastName": "Glinton"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5dd"
          },
          "accountEmailAddress": "frank.parhizgar@cannect.ca",
          "contact": [
            {
              "firstName": "Frank",
              "lastName": "Parhizgar"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5e0"
          },
          "accountEmailAddress": "kevin@cannect.ca",
          "contact": [
            {
              "firstName": "Kevin",
              "lastName": "Bautista"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5e1"
          },
          "accountEmailAddress": "rohit@cannect.ca",
          "contact": [
            {
              "firstName": "Rohit",
              "lastName": "Kaushik"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5e3"
          },
          "accountEmailAddress": "niko@cannect.ca",
          "contact": [
            {
              "firstName": "Niko",
              "lastName": "Markakis"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5e4"
          },
          "accountEmailAddress": "michael@mglenn.com",
          "contact": [
            {
              "firstName": "Michael",
              "lastName": "Glenn"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5e6"
          },
          "accountEmailAddress": "jalal@cannect.ca",
          "contact": [
            {
              "firstName": "Jalal",
              "lastName": "Farid"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5e7"
          },
          "accountEmailAddress": "ckitchen@cannect.ca",
          "contact": [
            {
              "firstName": "Chris",
              "lastName": "Kitchen"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5e8"
          },
          "accountEmailAddress": "podcast@cannect.ca",
          "contact": [
            {
              "firstName": "Vlad",
              "lastName": "Tiron"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5eb"
          },
          "accountEmailAddress": "demo@oscarintelligence.com",
          "contact": [
            {
              "firstName": "Demo",
              "lastName": "User"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ec"
          },
          "accountEmailAddress": "zorie.campbell@morcandirect.com",
          "contact": [
            {
              "firstName": "Zorie",
              "lastName": "Campbell"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ed"
          },
          "accountEmailAddress": "alexi@cannect.ca",
          "contact": [
            {
              "firstName": "Alexi",
              "lastName": "Markakis"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ee"
          },
          "accountEmailAddress": "chris@cannect.ca",
          "contact": [
            {
              "firstName": "Chris",
              "lastName": "Jodhan"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ef"
          },
          "accountEmailAddress": "jesse@cannect.ca",
          "contact": [
            {
              "firstName": "Jesse",
              "lastName": "George"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f0"
          },
          "accountEmailAddress": "francesco@cannect.ca",
          "contact": [
            {
              "firstName": "Francesco",
              "lastName": "Rizzello"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f1"
          },
          "accountEmailAddress": "info@morcandirect.com",
          "contact": [
            {
              "firstName": "MorcanDirect",
              "lastName": "Website"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f2"
          },
          "accountEmailAddress": "tawhida.hoque@morcandirect.com",
          "contact": [
            {
              "firstName": "Tawhida",
              "lastName": "Hoque - OLD"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f3"
          },
          "accountEmailAddress": "matthew.scanlan@cannect.ca",
          "contact": [
            {
              "firstName": "Matthew",
              "lastName": "Scanlan"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f4"
          },
          "accountEmailAddress": "anastasia@cannect.ca",
          "contact": [
            {
              "firstName": "Anastasia",
              "lastName": "Skoubouris"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f5"
          },
          "accountEmailAddress": "cameron.brown@morcandirect.com",
          "contact": [
            {
              "firstName": "Cameron",
              "lastName": "Brown"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f6"
          },
          "accountEmailAddress": "jason@cannect.ca",
          "contact": [
            {
              "firstName": "Jason",
              "lastName": "Gaudette"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f7"
          },
          "accountEmailAddress": "phil.edwards@morcandirect.com",
          "contact": [
            {
              "firstName": "Phil",
              "lastName": "Edwards"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f8"
          },
          "accountEmailAddress": "sanyun@cannect.ca",
          "contact": [
            {
              "firstName": "San",
              "lastName": "Yun Han"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5f9"
          },
          "accountEmailAddress": "nick@cannect.ca",
          "contact": [
            {
              "firstName": "Nick",
              "lastName": "Holland"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5fa"
          },
          "accountEmailAddress": "justin.turner@morcandirect.com",
          "contact": [
            {
              "firstName": "Justin Turner -",
              "lastName": "MorcanDirect"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5fb"
          },
          "accountEmailAddress": "mat@cannect.ca",
          "contact": [
            {
              "firstName": "Mat",
              "lastName": "Kerr"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5fd"
          },
          "accountEmailAddress": "ryan@cannect.ca",
          "contact": [
            {
              "firstName": "Ryan",
              "lastName": "Laljie"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5fe"
          },
          "accountEmailAddress": "che.chaitan@morcandirect.com",
          "contact": [
            {
              "firstName": "Che",
              "lastName": "Chaitan"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e5ff"
          },
          "accountEmailAddress": "lisa@cannect.ca",
          "contact": [
            {
              "firstName": "Lisa",
              "lastName": "Nguyen"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e600"
          },
          "accountEmailAddress": "tara.evans@morcandirect.com",
          "contact": [
            {
              "firstName": "Tara",
              "lastName": "Evans"
            }
          ]
        },
        {
          "_id": {
            "$oid": "633f6989497e207808d6e601"
          },
          "accountEmailAddress": "susan@cannect.ca",
          "contact": [
            {
              "firstName": "Susan",
              "lastName": "Morriss"
            }
          ]
        },
        {
          "_id": {
            "$oid": "63443d0a9823bd503aa1d7a4"
          },
          "accountEmailAddress": "rkaur@oscarintelligence.com",
          "contact": [
            {
              "firstName": "Rajwinderpal",
              "lastName": "Kaur"
            }
          ]
        },
        {
          "_id": {
            "$oid": "63443d0a9823bd503aa1d7a9"
          },
          "accountEmailAddress": "lbachellerie@oscarintelligence.com",
          "contact": [
            {
              "firstName": "Loic",
              "lastName": "Bachellerie"
            }
          ]
        },
        {
          "_id": {
            "$oid": "63443d0a9823bd503aa1d7ae"
          },
          "accountEmailAddress": "th@cannect.ca",
          "contact": [
            {
              "firstName": "Tawhida",
              "lastName": "Hoque"
            }
          ]
        },
        {
          "_id": {
            "$oid": "63443d0a9823bd503aa1d7c5"
          },
          "accountEmailAddress": "demo2@oscarintelligence.com",
          "contact": [
            {
              "firstName": "Demo",
              "lastName": "User Two"
            }
          ]
        },
        {
          "_id": {
            "$oid": "6354725a96186000fa78c584"
          },
          "accountEmailAddress": "bruce.lamb@avalanchesearch.com",
          "contact": [
            {
              "firstName": "Bruce",
              "lastName": "Lamb"
            }
          ]
        },
        {
          "_id": {
            "$oid": "637d5005aadeba4b9c0dbe1d"
          },
          "accountEmailAddress": "sifanduronto@gmail.com",
          "contact": [
            {
              "firstName": "Sifan",
              "lastName": "Ovi"
            }
          ]
        },
        {
          "_id": {
            "$oid": "637d5005aadeba4b9c0dbe26"
          },
          "accountEmailAddress": "pratima.waghmare@logiquad.com",
          "contact": [
            {
              "firstName": "Pratima",
              "lastName": "Waghmare"
            }
          ]
        },
        {
          "_id": {
            "$oid": "637d5005aadeba4b9c0dbe2a"
          },
          "accountEmailAddress": "priya.gandhi@infostride.com",
          "contact": [
            {
              "firstName": "Priya",
              "lastName": "Gandhi"
            }
          ]
        },
        {
          "_id": {
            "$oid": "637d5005aadeba4b9c0dbe2b"
          },
          "accountEmailAddress": "ejazkarimhunzai@gmail.com",
          "contact": [
            {
              "firstName": "Ejaz",
              "lastName": "Karim"
            }
          ]
        },
        {
          "_id": {
            "$oid": "637d5005aadeba4b9c0dbe30"
          },
          "accountEmailAddress": "akshay.kumar@infostride.com",
          "contact": [
            {
              "firstName": "Akshay",
              "lastName": "Kumar"
            }
          ]
        },
        {
          "_id": {
            "$oid": "637d5005aadeba4b9c0dbe31"
          },
          "accountEmailAddress": "nurul@ferdo.us",
          "contact": [
            {
              "firstName": "Nurul",
              "lastName": "Ferdous"
            }
          ]
        },
        {
          "_id": {
            "$oid": "637d5005aadeba4b9c0dbe33"
          },
          "accountEmailAddress": "vaishnavi@infostride.com",
          "contact": [
            {
              "firstName": "Vaishnavi",
              "lastName": ""
            }
          ]
        },
        {
          "_id": {
            "$oid": "637d5005aadeba4b9c0dbe36"
          },
          "accountEmailAddress": "rahul.choubey@infostride.com",
          "contact": [
            {
              "firstName": "Rahul",
              "lastName": "Choubey"
            }
          ]
        },
        {
          "_id": {
            "$oid": "63921a58118d0de3a248c410"
          },
          "accountEmailAddress": "psoy@mvpmortgagesolutions.ca",
          "contact": [
            {
              "firstName": "Bun-Phaktra (Patrick)",
              "lastName": "Soy"
            }
          ]
        },
        {
          "_id": {
            "$oid": "63c20a12d7b0eb8474acabfd"
          },
          "accountEmailAddress": "jatin.patel@hitechdigital.com",
          "contact": [
            {
              "firstName": "Jatin",
              "lastName": "Patel"
            }
          ]
        },
        {
          "_id": {
            "$oid": "63c5d8880c3837a10743e377"
          },
          "accountEmailAddress": "neil@cannect.ca",
          "contact": [
            {
              "firstName": "Neil",
              "lastName": "Oman"
            }
          ]
        },
        {
          "_id": {
            "$oid": "63c5ed1c2ef607ffa01a6800"
          },
          "accountEmailAddress": "jmvbxx@gmail.com",
          "contact": [
            {
              "firstName": "",
              "lastName": "Jason"
            }
          ]
        },
        {
          "_id": {
            "$oid": "661452cf2046330012a056cb"
          },
          "accountEmailAddress": "info@cannect.ca",
          "contact": [
            {
              "firstName": "Make",
              "lastName": "Money Count"
            }
          ]
        }
        ]
    }
  },

  computed: {
    getAgents(){
      return this.agents.map(a => {
        try{
          return {text: `${a.contact[0].firstName} ${a.contact[0].lastName}`, value: a._id.$oid}
        } catch (e) {

        }
      }).sort((a,b)=> a.text.localeCompare(b.text))
    },
    ...mapState('campaigns', [
      'campaign'
    ]),
    ...mapState('filters', [
      'filters', 'contactFilters', 'leadFilters'
    ]),

    ...mapState('campaign_categories', [
      'categories'
    ]),
    getFilters() {
      return this.filter_model === 'contact' ? this.contactFilters : (this.filter_model === 'lead' ? this.leadFilters : this.filters)
    },

    name: {
      get() { return this.$store.state.campaigns.campaign.name },
      set(value) { this.updateAttribute({ attribute: 'name', value }) }
    },
    agent: {
      get() { return this.$store.state.campaigns.campaign.agent },
      set(value) { this.updateAttribute({ attribute: 'agent', value }) }
    },
    category_name: {
      get() { return this.$store.state.campaigns.campaign.category_name },
      set(value) { this.updateAttribute({ attribute: 'category_name', value }) }
    },

    filter_id: {
      get() { return this.$store.state.campaigns.campaign.filter_id },
      set(value) { this.updateAttribute({ attribute: 'filter_id', value }) }
    },

    filter_model: {
      get() { return this.$store.state.campaigns.campaign.filter_model },
      set(value) { this.updateAttribute({ attribute: 'filter_model', value }) }
    },

    use_assigned_agent: {
      get() { return this.$store.state.campaigns.campaign.use_assigned_agent },
      set(value) { this.updateAttribute({ attribute: 'use_assigned_agent', value }) }
    },
    only_unique_emails: {
      get() { return this.$store.state.campaigns.campaign.only_unique_emails },
      set(value) { this.updateAttribute({ attribute: 'only_unique_emails', value }) }
    },
    active: {
      get() { return this.$store.state.campaigns.campaign.active },
      set(value) { this.updateAttribute({ attribute: 'active', value }) }
    }
  },

  methods: {
    ...mapActions('campaigns', [
      'updateCampaign',
      'updateAttribute'
    ]),

    filterChanged(filterId) {
      this.updateAttribute({ attribute: 'filter_snapshot', value: serializer.revive(this.filters[filterId]) })
    }
  }
}
</script>
